<template>
  <div class="login-page">
    <div class="login-wrap">
      <div class="title">
        <img class="logo" src="../../assets/images/logo.png" alt="衣加加云平台" title="衣加加云平台">
      </div>

      <div class="sub-title">
        重置密码
      </div>

      <el-form :model="setPasswordForm" :rules="rules" ref="setPasswordForm" class="form-wrap">

        <el-form-item prop="password1">
          <el-input v-model.trim="setPasswordForm.password1"
            type="password"
            placeholder="请输入6~16位组合密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password2">
          <el-input v-model.trim="setPasswordForm.password2"
            type="password"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号码" v-model.trim="setPasswordForm.phone"></el-input>
        </el-form-item>
        
        <el-form-item prop="code">
          <el-col :span="16">
            <el-input placeholder="请输入验证码" v-model="setPasswordForm.code"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button :disabled="!getCodeFlag" style="width: 96%;margin-left: 4%;" @click="getCodeHandle">
              {{getCodeFlag ? '获取验证码' : codeSeconds + 's'}}
            </el-button>
          </el-col>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="toCodeLogin" class="login-btn" :class="{opa: loading}"><i class="el-icon-loading" v-show="loading"></i>提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="login-footer">
      <y-footer />
    </div>
    
  </div>
</template>

<script>
import yFooter from '../../components/yFooter.vue'
import { validateMobile, validateCombinationPwd } from '@/utils/validate.js'
import request from '@/utils/request.js'
import api from '@/api/index.js'
export default {
  components: {
    yFooter
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!validateMobile(value)){
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!validateCombinationPwd(value)) {
        callback(new Error('请输入6-16位组合密码'))
      } else {
        callback();
      }
    }
    var validatePass2 = (rule, value, callback) => {
      // console.log(value,value,value)
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.setPasswordForm.password1) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback();
      }
    }
    return {
      getCodeFlag: true, // 获取验证码按钮标志
      codeTimer: null,   // 验证码定时器
      codeSeconds: 60,   // 剩余秒数

      loading: false, // 提交loading

      setPasswordForm: {
        password1: '',
        password2: '',
        phone: '',
        code: ''
      },

      rules: {
        password1: [
          { validator: validatePass1, trigger: 'blur' }
        ],
        password2: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {

  },
  methods: {
    // 获取验证码
    getCodeHandle() {
      if (!this.getCodeFlag) return;
      this.$refs['setPasswordForm'].validateField('phone', (err) => {
        if (!err) {
          this.getCodeFlag = false
          request({
            url: api.requestForgetPasswdCode,
            noAuth: true,
            data: {
              phone: this.setPasswordForm.phone
            }
          }).then(res => {
            if (res.errorCode === 200) {
              this.$message.success('验证码发送成功')
              this.codeSeconds = 60
              this.codeTimer = setInterval(() => {
                if (this.codeSeconds > 0) {
                  this.codeSeconds --
                } else {
                  clearInterval(this.codeTimer)
                  this.getCodeFlag = true
                }
              }, 1000)
            } else {
              this.$message.error('验证码发送失败')
              this.getCodeFlag = true
            }
          }).catch(err => {
              this.getCodeFlag = true
          })
        }
      })
    },
    // 通过验证码登录
    toCodeLogin() {
      if (this.loading) return
      this.$refs['setPasswordForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let device = window.navigator.userAgent
          request({
            url: api.requestForgetPassWd,
            method: 'post',
            noAuth: true,
            data: {
              "phone": this.setPasswordForm.phone,
              "code": this.setPasswordForm.code,
              "passWd": this.setPasswordForm.password1,
							"checkPassWd": this.setPasswordForm.password2
            }
          }).then(res => {
            // console.log('api.requestForgetPassWd:res', res)
            if (res.errorCode == 200) {
              this.$message.success('密码设置成功') 
              this.$router.go(-1)
            } else {
              this.$message.error(res.errorMsg || '操作失败') 
            }
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #f0f5fe;
}
.login-wrap {
  width: 368px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -260px 0  0 -184px;
  .title {
    .logo {
      width: 294px;
      height: 44px;
      display: block;
      margin: 0 auto;
    }
  }

  .sub-title {
    margin-top: 64px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }

  .form-wrap {
    margin-top: 24px;
    .btn-forget-wrap {
      text-align: right;
      .btn-forget {
        padding: 0;
      }
    }
    .login-btn {
      width: 100%;
      margin-top: 32px;
      &.opa {
        opacity: 0.5;
      }
    }
  }
}
.login-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>